export default __webpack_public_path__ + "static/media/S.0076ec70.svg";